import React from "react";
import Lottie from "lottie-react";
import loaderAnimation from "../../assets/Lottie_json/AirHomeLoader.json";

function AirHomeLoader() {
  return (
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 9999,
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        padding: "10px",
        borderRadius: "10px",
      }}
    >
      <Lottie
        animationData={loaderAnimation}
        loop
        style={{ width: 100, height: 100 }}
      />
    </div>
  );
}

export default AirHomeLoader;
